<template>
  <div class="projects-container container-fluid">
    <Suspense>
      <template #default>
        <!--CustomersTable></CustomersTable-->
        <router-view></router-view>
      </template>

      <template #fallback>
        <div>Loading all customers..</div>
      </template>
    </Suspense>
  </div>
</template>

<script setup lang="ts">
//import CustomersTable from './List.vue';
</script>
